import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { sound } from "@pixi/sound";
import { BitmapText, Color, Container, FillGradient, Sprite, Text, TextStyle } from "pixi.js";
import { Group, Tween } from "tweedle.js";
import { currentBackgorundMusic, currentBackgorundMusicVolume, getMobileDetect, isMusicBtnOnGlobal, languageGlobal, setBackgorundMusic } from "../config/GlobalVariableConfig";
import { getFontConfig } from "../config/introTextConfig";
import { SoundManager } from "../core/SoundManager";
import { isFireFox } from "../core/utils";
import { GameConstants } from "../gameClientEvents/GameConstants";
import { SoundConstants } from "../gameClientEvents/SoundConstants";


declare const window: any;
const translationManager = window.hacksawCasino.Translation;

export class Banner extends Container {

    private bgContainer = new Container();
    private texContainer = new Container(); //-- which needed to scale without any limit
    private charContainer = new Container();


    private backgroundImg: Sprite;
    // private backgroundMidImg: Sprite;

    private bannerText1: Text = new Text({});
    private bannerText2: Text = new Text({});
    private bannerText3: Text = new Text({});
    private transition: Spine | null = null;
    // private bannerText4: Text = new Text({});
    // private bannerText5: Text = new Text({});
    private continueText: Text = new Text({});

    // private backgroundSpine: Spine | null = null;

    private winText: BitmapText = new BitmapText({
        text: "",
        style: {
            fontFamily: "scarab_wins_digit",
            trim: true,
            fontSize: 120,
            letterSpacing: 5,
        }
    });

    // private leftCharacter: Sprite | null = null;
    // private rightCharacter: Sprite | null = null;

    private tweenGroup: Group = new Group();

    private screenWidth: number;
    private screenHeight: number;
    intro_outro: Spine;
    private bannerTransition: Spine | null = null;


    constructor(screenWidth: number, screenHeight: number) {
        super();



        this.screenWidth = screenWidth;
        this.screenHeight = screenHeight;

        this.setupBGImage();

        this.setupBackground();
        this.setupBannerText();

        this.setupCharacter();

        this.visible = false;

        // this.bgContainer.eventMode = "static"
        this.resize(screenWidth, screenHeight);

    }

    private playTransition() {
        this.transition = Spine.from({
            skeleton: "bannerTransitionSkel",
            atlas: "bannerTransitionAtlas",
        });
        this.transition.label = "bannerTransition";
        this.bannerTransition = this.transition;
        this.addChild(this.transition);
        this.layoutTransition(this.transition);
    }

    private layoutTransition(transition: Spine): void {
        // Banner lives in stage coordinates; center the transition on the screen.
        transition.position.set(this.screenWidth / 2, this.screenHeight / 2);

        // Match the "full background" scaling used by the banner background image.
        const bgScale = this.backgroundImg?.scale?.x ?? 1;
        transition.scale.set(bgScale, bgScale);
    }

    public startTransition() {
        this.playTransition();
    }

    private setupBGImage(): void {
        // this.backgroundImg.label = "backgroundImg";

        this.backgroundImg = Sprite.from("banner_bg");
        this.backgroundImg.alpha = 0;
        this.addChild(this.backgroundImg);


    }
    private setupBackground(): void {

        this.addChild(this.bgContainer);


        this.addChild(this.texContainer);

        this.addChild(this.charContainer);

    }

    private setupCharacter(): void {


        this.intro_outro = Spine.from({
            skeleton: "freegame_intro_outro_skel",
            atlas: "freegame_intro_outro_atlas"
        })
        this.intro_outro.visible = false;
        this.intro_outro.position.set(100, 400);
        this.bgContainer.addChild(this.intro_outro);

        // this.leftCharacter = Sprite.from('sideCharacter');
        // this.leftCharacter.position.set(600, 250);
        // this.leftCharacter.scale.set(-0.75, 0.75);
        // this.bgContainer.addChild(this.leftCharacter);

        // this.rightCharacter = Sprite.from('sideCharacter');
        // this.rightCharacter.position.set(1350, 250);
        // this.bgContainer.addChild(this.rightCharacter);
        // this.rightCharacter.scale.set(0.75, 0.75);
    }


    private setupBannerText(): void {

        const {
            fontFamily: fontFamilyHeading,
            fontWeight: fontWeightHeading,
            fontSize: fontSizeHeading,
        } = getFontConfig(languageGlobal, "introHeading");



        const fill = new FillGradient(0, 0, 0, 32 * 1 * 3);

        const colors = ["#fdea00", "#fbf8cb", "#fee500"].map((color) => Color.shared.setValue(color).toNumber());

        colors.forEach((number, index) => {
            const ratio = index / colors.length;

            fill.addColorStop(ratio, number);
        });

        this.bannerText1.style = new TextStyle({
            fontFamily: fontFamilyHeading,
            fill: isFireFox() ? "#D4FFFC" : { fill },
            fontWeight: fontWeightHeading,
            fontSize: fontSizeHeading,
            stroke: {
                color: "#a51300",
                width: 3,
            },
            dropShadow: {
                blur: 5,
                color: "#000000",
                distance: 5,
            },
            letterSpacing: 1,
            align: "center",
            // breakWords: true,
            // wordWrap: true,
            // wordWrapWidth: 850,

        });



        const {
            fontFamily: fontFamilyDesc1,
            fontWeight: fontWeightDesc1,
            fontSize: fontSizeDesc1,
            lineHeight: lineHeightDesc1
        } = getFontConfig(languageGlobal, "introDesc1");

        this.bannerText2.style = new TextStyle({
            fontFamily: fontFamilyDesc1,
            fill: "#D4FFFC",
            fontWeight: fontWeightDesc1,
            fontSize: fontSizeDesc1,
            align: "center",
            // trim: true,
            letterSpacing: 1,
            // fontVariant: "small-caps",
            breakWords: true,
            wordWrap: true,
            wordWrapWidth: 1000,
            lineHeight: lineHeightDesc1,
        });


        const {
            fontFamily: fontFamilyDesc2,
            fontWeight: fontWeightDesc2,
            fontSize: fontSizeDesc2,
            lineHeight: lineHeightDesc2
        } = getFontConfig(languageGlobal, "introDesc2");

        const desc2TextStyle = new TextStyle({
            fontFamily: fontFamilyDesc2,
            fill: "#D4FFFC",
            fontWeight: fontWeightDesc2,
            fontSize: fontSizeDesc2,
            align: "center",
            wordWrap: true,
            // trim: true,
            letterSpacing: 1,
            wordWrapWidth: 1000,
            lineHeight: lineHeightDesc2,
            breakWords: true,
        });

        this.bannerText3.style = desc2TextStyle;
        if (languageGlobal === "zh-tw") {
            this.bannerText3.style.fontSize = 42;
        }
        // this.bannerText4.style = desc2TextStyle;
        // this.bannerText5.style = desc2TextStyle;


        const {
            fontFamily: fontFamilyContinue,
            fontWeight: fontWeightContinue,
            fontSize: fontSizeContinue2,
        } = getFontConfig(languageGlobal, "introContinue");

        const continueTextStyle = new TextStyle({
            fontFamily: fontFamilyContinue,
            fill: isFireFox() ? "#D4FFFC" : { fill },//"#ffffff",
            fontWeight: fontWeightContinue,
            fontSize: fontSizeContinue2,
            stroke: {
                color: "#744303",
                width: 3,
            },
            dropShadow: isFireFox() ? false :
                {
                    blur: 5,
                    color: "#000000",
                    distance: 6,
                },
        });

        this.continueText.text = translationManager.game('intro_continue_uc')
        this.continueText.style = continueTextStyle


        this.bannerText1.anchor.set(0.5);
        this.bannerText2.anchor.set(0.5);
        this.bannerText3.anchor.set(0.5);
        // this.bannerText4.anchor.set(0.5);
        // this.bannerText5.anchor.set(0.5);
        this.continueText.anchor.set(0.5);
        this.winText.anchor.set(0.5);

        // const spacing = 20;
        this.texContainer.addChild(this.bannerText1);
        this.texContainer.addChild(this.bannerText2);
        this.texContainer.addChild(this.bannerText3);
        // this.texContainer.addChild(this.bannerText4);
        // this.texContainer.addChild(this.bannerText5);
        this.texContainer.addChild(this.continueText);
        this.texContainer.addChild(this.winText);
    }

    public async appearFreeGameIntroBanner(freeGameNumber: number) {

        return new Promise<void>(async (resolve) => {

            // Transition BEFORE banner appears; on transition "change" marker, proceed with banner


            // this.visible = true;
            this.bannerText1.visible = true;
            this.bannerText2.visible = true;
            this.intro_outro.visible = false;
            this.bannerText3.visible = true;
            this.backgroundImg.visible = true;
            // this.bannerText4.visible = true;
            // this.bannerText5.visible = true;

            this.winText.visible = false;

            this.bannerText1.scale = 1;
            this.bannerText1.text = translationManager.game('banner_intro_heading_uc');// '8-BIT BONUS';
            this.bannerText1.scale = Math.min(1, 800 / this.bannerText1.width);
            this.bannerText1.x = 20;
            this.bannerText1.y = -100;

            // this.bannerText2.scale = 1;

            this.bannerText2.text = translationManager.game('banner_intro_desc_1', null, { 'freegamenumber': freeGameNumber });
            this.bannerText2.scale = Math.min(1, 820 / this.bannerText2.width);
            this.bannerText2.x = 20;
            this.bannerText2.y = 15;
            // this.bannerText2.scale = Math.min(1, 850 / this.bannerText2.width);

            this.bannerText3.text = translationManager.game('banner_intro_desc_2');//'During the bonus game, the multiplier accumulates with each win that involves a wild symbol with a multiplier.';
            this.bannerText3.x = 20;
            this.bannerText3.y = 155;
            // this.bannerText3.scale = Math.min(1, (this.bannerBackground.width - 150) / this.bannerText3.width);

            // this.bannerText4.text = translationManager.game('banner_intro_desc_3');//'The multiplier persists throughout the entire duration of the bonus game.';
            // this.bannerText4.y = 110;

            // this.bannerText5.text = translationManager.game('banner_intro_desc_4');//'The multiplier persists throughout the entire duration of the bonus game.';
            // this.bannerText5.y = 250;
            this.continueText.x = 20;
            this.continueText.y = 300;


            this.texContainer.alpha = 0;
            this.texContainer.scale = 0;

            this.visible = true;

            // SoundManager.play('free_Game_Banner', { volume: 0.5 });

            // this.backgroundSpine.state.setAnimation(0, "in", false).listener = {
            //     complete: async () => {
            //         this.backgroundSpine.state.setAnimation(0, "loop", true);

            //         await this.appearText(true);
            //         resolve();

            //         this.backgroundSpine.state.clearListeners();
            //     }
            // };


            await new Promise<void>((resolve) => {
                const obj = { alpha: 0 };
                const tween = new Tween(obj, this.tweenGroup)
                    .to({ alpha: 0 }, 200)
                    .onUpdate(() => {
                        // this.backgroundImg.alpha = obj.alpha;
                        // this.backgroundMidImg.alpha = obj.alpha;
                    })
                    .onStart(() => {
                        SoundManager.play(SoundConstants.FEATURE_BANNER, { volume: 0.8 });
                    })
                    .onComplete(() => {
                        this.tweenGroup.remove(tween);
                        resolve()
                    })
                    .start();
            })
            this.backgroundImg.alpha = 1;


            const promises: Promise<void>[] = [];
            this.intro_outro.visible = true;

            const playInAnimation = (characterSpine: Spine) => {
                return new Promise<void>((resolveCharacter) => {
                    const state = characterSpine.state;

                    const onComplete = (entry: any) => {
                        if (entry.animation.name === "in") {
                            state.setAnimation(0, "loop", true);
                            state.removeListener(listener);
                            resolveCharacter();
                        }
                    };

                    const listener = { complete: onComplete };

                    state.addListener(listener);
                    state.setAnimation(0, "in", false);
                    this.intro_outro.visible = true;
                });
            };

            // promises.push(playInAnimation(this.leftCharacter));
            promises.push(playInAnimation(this.intro_outro));



            // promises.push(playInAnimation(this.rightCharacter));

            Promise.all(promises).then(async () => {
                this.continueText.visible = false;
                await this.appearText(true);

                this.continueText.visible = true;
                await new Promise<void>((resolvePop) => {
                    this.continueText.scale.set(0);
                    this.continueText.alpha = 0;

                    const popTween = new Tween(
                        { scale: 0, alpha: 0 },
                        this.tweenGroup
                    )
                        .to({ scale: 1.2, alpha: 1 }, 200)        // grow + fade in
                        .onUpdate((obj) => {
                            this.continueText.scale.set(obj.scale);
                            this.continueText.alpha = obj.alpha;
                        })
                        .chain(
                            new Tween({ scale: 1.2 }, this.tweenGroup)
                                .to({ scale: 1.0 }, 150)           // settle
                                .onUpdate((obj) => {
                                    this.continueText.scale.set(obj.scale);
                                })
                                .onComplete(() => {
                                    this.tweenGroup.remove(popTween);
                                    resolvePop();
                                })
                        )
                        .start();
                });
                resolve();
            });

        })


    }

    private appearText(toFreeGame: boolean) {

        return new Promise<void>((resolve) => {

            let textScale;
            if (this.screenWidth > this.screenHeight) {
                textScale = Math.min(this.screenWidth / 1920, this.screenHeight / 1080);
            }
            else {
                textScale = Math.min(this.screenWidth / 1080, this.screenHeight / 1920);
            }

            this.texContainer.alpha = 0;
            this.texContainer.scale = 0;
            const tweenAlpha = new Tween(this.texContainer, this.tweenGroup)
                // .to({ alpha: 1 }, 200)
                .to({ scale: { x: textScale, y: textScale }, alpha: 1 }, 500)
                // .easing(Easing.Bounce.Out)
                .onStart(() => {
                    this.switchTheBackgroundMusic(toFreeGame);
                })
                .onComplete(() => {
                    this.eventMode = "static";
                    // this.bgContainer.cursor = 'pointer';
                    this.tweenGroup.remove(tweenAlpha);

                    resolve();
                })
                .start();

            const tweenBreath = new Tween(this.continueText.scale, this.tweenGroup)
                .to({ x: 1.03, y: 1.03 }, 1000) // Scale up
                .yoyo(true) // Automatically reverses the tween
                .repeat(Infinity) // Infinite loop
                .onComplete(() => {
                    this.tweenGroup.remove(tweenBreath);
                })
                .start();

        })

    }

    private switchTheBackgroundMusic(toFreeGame: boolean) {

        let targetMusicLoop;
        if (toFreeGame) {
            targetMusicLoop = SoundManager.find(SoundConstants.FREEGAME_MUSIC);
        }
        else {
            targetMusicLoop = SoundManager.find(SoundConstants.BASE_MUSIC);
        }

        let currentVal: number = currentBackgorundMusicVolume;
        let targetVal: number = 0;

        const tween = new Tween({ x: currentVal }, this.tweenGroup)
            .to({ x: targetVal }, 750)
            .onUpdate((object) => {
                currentBackgorundMusic.volume = object.x;
                // console.log("this.backGroundMusic", this.backGroundMusic.volume);
            })
            .onComplete(() => {
                this.tweenGroup.remove(tween);
                playFgMusic();

            })
            .start();


        const playFgMusic = () => {
            let currentVal: number = .10;
            let targetVal: number = currentBackgorundMusicVolume;

            // initialize with ambient sound
            setBackgorundMusic(targetMusicLoop);

            const tween = new Tween({ x: currentVal }, this.tweenGroup)
                .to({ x: targetVal }, 750)
                .onStart(() => {
                    currentBackgorundMusic.loop = true;
                    currentBackgorundMusic.singleInstance = true;
                    currentBackgorundMusic.play();
                    currentBackgorundMusic.muted = !isMusicBtnOnGlobal;
                })
                .onUpdate((object) => {
                    currentBackgorundMusic.volume = object.x;

                    // console.log("this.backGroundMusic", this.backGroundMusic.volume);
                })
                .onComplete(() => {
                    this.tweenGroup.remove(tween);
                })
                .start();
        }
    }



    public async disappearBanner(): Promise<void> {
        return new Promise<void>(async (resolve) => {


            // if (!isBase) {
            //     this.switchTheBackgroundMusic(false);
            // }

            this.texContainer.alpha = 0;
            this.texContainer.scale = 0;


            const promises: Promise<void>[] = [];

            const playOutAnimation = async (characterSpine: Spine) => {
                return await new Promise<void>((resolveCharacter) => {
                    characterSpine.state.setAnimation(0, "out", false).listener = {
                        event: (_entry, event) => {
                            if (event.data.name === "change") {
                            }
                        },

                        complete: () => {
                            characterSpine.state.clearListeners();
                            this.backgroundImg.visible = false;
                            resolveCharacter();
                        }
                    };
                });
            };

            // promises.push(playOutAnimation(this.leftCharacter));
            // promises.push(playOutAnimation(this.rightCharacter));
            promises.push(playOutAnimation(this.intro_outro));

            this.playTransition();

            await new Promise<void>((resolveTransition) => {

                const listener = {
                    event: (_entry: any, event: any) => {
                        if (event.data.name === "event") {
                            this.backgroundImg.alpha = 0;
                        }
                    },

                    complete: () => {

                        this.transition.state.removeListener(listener);

                        if (this.bannerTransition === this.transition) {
                            this.removeChild(this.transition);
                            this.transition.destroy(true);
                            this.bannerTransition = null;
                        }

                        resolveTransition();
                    }
                };

                this.transition.state.addListener(listener);

                // START animation AFTER listener added
                sound.play(SoundConstants.STONE_TRANSITION, { volume: 1 });
                this.transition.state.setAnimation(0, "animation", false);
            });
            // const obj = { alpha: 1 };
            // await new Promise<void>((resolve) => {
            //     const tween = new Tween(obj, this.tweenGroup)
            //     .to({ alpha: 0 }, 200)
            //     .onUpdate(() => {
            //             this.backgroundImg.alpha = obj.alpha;

            //         })
            //         .onComplete(() => {
            //             this.tweenGroup.remove(tween);

            //             resolve()
            //         })
            //         .start();
            //     })


            Promise.all(promises).then(() => {
                this.visible = false;
                this.eventMode = "none";
                // this.bgContainer.cursor = 'none';
                resolve();
            });
        });
    }

    public async appearFreeGameOutroBanner(totalWin: number, freeSpins: number) {

        return new Promise<void>(async (resolve) => {

            // Transition BEFORE banner appears; on transition "change" marker, proceed with banner

            this.visible = true;

            this.bannerText3.visible = false;

            this.backgroundImg.visible = true;
            // this.bannerText4.visible = false;
            // this.bannerText5.visible = false;

            this.winText.visible = true;

            this.bannerText1.scale = 1;
            this.bannerText1.text = translationManager.game('banner_outro_heading_uc');// '8-BIT BONUS';
            this.bannerText1.scale = Math.min(1, 900 / this.bannerText1.width);
            this.bannerText1.x = 0;
            this.bannerText1.y = -125;

            this.backgroundImg.alpha = 1;
            // this.bannerText2.scale = 1;

            this.bannerText2.text = translationManager.game('banner_outro_desc_1', null, { 'winnumber': freeSpins });
            this.bannerText2.scale = Math.min(1, 750 / this.bannerText2.width);
            this.bannerText2.x = 0;
            this.bannerText2.y = -50;
            // this.bannerText2.scale = Math.min(1, 850 / this.bannerText2.width);


            this.winText.scale = 1;
            this.winText.text = totalWin.toFixed(2);
            this.winText.scale = Math.min(1, 900 / this.winText.width);
            this.winText.x = 20;
            this.winText.y = 100;

            this.continueText.x = 0;
            this.continueText.y = 275;


            this.texContainer.alpha = 0;
            this.texContainer.scale = 0;

            const obj = { alpha: 0 };
            const tween = new Tween(obj, this.tweenGroup)
                .to({ alpha: 1 }, 200)
                .onUpdate(() => {
                    this.backgroundImg.alpha = obj.alpha;
                    // this.backgroundMidImg.alpha = obj.alpha;
                })
                .onStart(() => {
                    // SoundManager.play('free_Game_Banner', { volume: 1 });
                    SoundManager.play(SoundConstants.TOTAL_WIN, { volume: 0.5 });
                })
                .onComplete(() => {
                    this.tweenGroup.remove(tween);
                })
                .start();

            // SoundManager.play('free_Game_Banner', { volume: 0.25 });
            const promises: Promise<void>[] = [];

            const playInAnimation = (characterSpine: Spine): Promise<void> => {
                return new Promise<void>((resolveCharacter) => {
                    characterSpine.state.setAnimation(0, "in", false).listener = {
                        complete: () => {
                            characterSpine.state.setAnimation(0, "loop", true);
                            characterSpine.state.clearListeners();
                            // const game = new BaseGameScene();
                            // await Manager.changeScene(game, false);
                            resolveCharacter();
                        }
                    };
                });
            };

            // promises.push(playInAnimation(this.leftCharacter));
            // promises.push(playInAnimation(this.rightCharacter));
            promises.push(playInAnimation(this.intro_outro));

            Promise.all(promises).then(async () => {
                await this.appearText(false);
                resolve();
            });

        });






    }




    public resize(screenWidth: number, screenHeight: number): void {

        this.screenWidth = screenWidth;
        this.screenHeight = screenHeight;

        let scale: number;

        let bgScale;
        const BG_SCALE_FACTOR = Math.max(screenWidth / GameConstants.BACKGROUND_SIZE, screenHeight / GameConstants.BACKGROUND_SIZE);


        if (screenWidth > screenHeight) {
            scale = Math.min(screenWidth / GameConstants.GAME_RES_WIDTH, screenHeight / GameConstants.GAME_RES_HEIGHT);
            bgScale = Math.max(scale, BG_SCALE_FACTOR);




            this.texContainer.scale.set(scale, scale);

            const xPos = (GameConstants.BACKGROUND_SIZE * bgScale - screenWidth) / 2;
            const yPos = (GameConstants.BACKGROUND_SIZE * bgScale - screenHeight) / 2;

            this.backgroundImg.scale = bgScale;
            this.backgroundImg.x = -xPos;
            this.backgroundImg.y = -yPos;
            if (this.bannerTransition) this.layoutTransition(this.bannerTransition);

            // this.leftCharacter.scale = 0.6;
            // this.leftCharacter.position.set(350, 680);
            this.intro_outro.scale = 0.8;
            if (getMobileDetect) {
                this.intro_outro.position.set(950, 675);
            } else {
                this.intro_outro.position.set(950, 450);

            }
            // this.rightCharacter.scale = 0.8;
            // this.rightCharacter.position.set(1630, 575);

            // this.backgroundMidImg.scale = 1;
            // this.backgroundMidImg.position.set(355, -90);
            this.bgContainer.scale.set(scale, scale)
            const bgXPos = (1920 * scale - screenWidth) / 2;
            const bgYPos = (1080 * scale - screenHeight) / 2;
            this.bgContainer.position.set(-bgXPos, -bgYPos);
            this.charContainer.scale.set(scale, scale)
            this.charContainer.position.set(-bgXPos, -bgYPos);

            this.texContainer.position.set(screenWidth / 2, screenHeight / 2);
            // this.leftCharacter.visible = true;
            // this.rightCharacter.visible = true;
        }
        else {
            scale = Math.min(screenWidth / GameConstants.GAME_RES_HEIGHT, screenHeight / GameConstants.GAME_RES_WIDTH);
            bgScale = Math.max(scale, BG_SCALE_FACTOR);


            this.texContainer.scale.set(scale, scale);

            const xPos = (GameConstants.BACKGROUND_SIZE * bgScale - screenWidth) / 2;
            const yPos = (GameConstants.BACKGROUND_SIZE * bgScale - screenHeight) / 2;

            this.backgroundImg.scale = bgScale;
            this.backgroundImg.x = -xPos;
            this.backgroundImg.y = -yPos;
            if (this.bannerTransition) this.layoutTransition(this.bannerTransition);

            // this.leftCharacter.scale = 0.6;
            // this.leftCharacter.position.set(600, -175);
            this.intro_outro.scale = 1;
            if (getMobileDetect) {
                this.intro_outro.position.set(950, 600);
            } else {

                this.intro_outro.position.set(950, 350);
            }
            // this.rightCharacter.scale = 0.75;
            // this.rightCharacter.position.set(1305, 1125);

            // this.backgroundMidImg.scale = 1;
            // this.backgroundMidImg.position.set(340, -90);

            this.bgContainer.scale.set(scale, scale)
            const bgXPos = (1920 * scale - screenWidth) / 2;
            const bgYPos = (1080 * scale - screenHeight) / 2;
            this.bgContainer.position.set(-bgXPos, -bgYPos);
            this.charContainer.scale.set(scale, scale)
            this.charContainer.position.set(-bgXPos, -bgYPos);

            this.texContainer.position.set((screenWidth / 2) - 16 * scale, screenHeight / 2);
            // this.leftCharacter.visible = false;
            // this.rightCharacter.visible = false;
        }



    }

    public update(): void {
        // Update the tween group
        this.tweenGroup.update();

    }
}
